// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.repository.managed.managed_repository_workspace.ManagedRepositoryWorkspace

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { RepositoryChangeData, RepositoryChangeStore } from "./RepositoryChange.generated";
import { FileConflictsData, FileConflictsStore } from "./FileConflicts.generated";
import { ManagedRepositoryWorktreeData, ManagedRepositoryWorktreeStore } from "./ManagedRepositoryWorktree.generated";

export interface ManagedRepositoryWorkspaceData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "ManagedRepositoryWorkspace";
    name: string;
    changes: RepositoryChangeData[];
    conflicts: FileConflictsData[];
    ahead: number;
    behind: number;
    worktrees: ManagedRepositoryWorktreeData[];
    pending_merge: boolean;
    can_commit: boolean;
}

export class ManagedRepositoryWorkspaceStore {
    readonly _entity_class_name = "ManagedRepositoryWorkspace" as const;
    name: string;
    changes: RepositoryChangeStore[];
    conflicts: FileConflictsStore[];
    ahead: number;
    behind: number;
    worktrees: ManagedRepositoryWorktreeStore[];
    pending_merge: boolean;
    can_commit: boolean;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: ManagedRepositoryWorkspaceData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]);
        this.changes = wrapEntity(data.changes, transport, [...chainPath, "changes"]);
        this.conflicts = wrapEntity(data.conflicts, transport, [...chainPath, "conflicts"]);
        this.ahead = wrapEntity(data.ahead, transport, [...chainPath, "ahead"]);
        this.behind = wrapEntity(data.behind, transport, [...chainPath, "behind"]);
        this.worktrees = wrapEntity(data.worktrees, transport, [...chainPath, "worktrees"]);
        this.pending_merge = wrapEntity(data.pending_merge, transport, [...chainPath, "pending_merge"]);
        this.can_commit = wrapEntity(data.can_commit, transport, [...chainPath, "can_commit"]);
        makeObservable(this, {
            name: observable,
            changes: observable,
            conflicts: observable,
            ahead: observable,
            behind: observable,
            worktrees: observable,
            pending_merge: observable,
            can_commit: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async get_sandbox(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "get_sandbox", [], {});
    }

    async abort_merge(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "abort_merge", [], {});
    }

    async refresh(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "refresh", [], {});
    }

    async stage(paths?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "stage", [paths], {});
    }

    async unstage(paths?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "unstage", [paths], {});
    }

    async revert(paths?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "revert", [paths], {});
    }

    async reset(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "reset", [], {});
    }

    async commit(message: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "commit", [message], {});
    }

    async diff(path: any, a?: any, staged?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "diff", [path, a, staged], {});
    }

    async push(remote?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "push", [remote], {});
    }

    async set_identity(name: any, email: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "set_identity", [name, email], {});
    }

    async pull(remote?: any, allow_merge?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "pull", [remote, allow_merge], {});
    }

    async get_or_create_worktree(session_id: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "get_or_create_worktree", [session_id], {});
    }
}

registerEntity("ManagedRepositoryWorkspace", ManagedRepositoryWorkspaceStore);
